import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  FAQ,
  IconSuccess,
} from '../../components';

import css from './InstantBookingPage.module.css';

const InstantBookingPage = () => {
  return (
    <StaticPage
      title="Instant Book"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'InstantBookingPage',
        description: 'Instant Book information on localtrailerhire.com.au',
        name: 'Instant Book page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <ul className={css.sections}>
            <li className={css.section}>
              <div className={`${css.sectionContent} ${css.columns}`}>
                <h1 className={css.sectionTitle}>Skip the wait. Confirm your hire instantly.</h1>
                <div>
                  <p>
                    With Instant Book, there's no need to wait for the owner to approve your hire
                    request. Once you place your booking, it's automatically confirmed and you'll
                    receive the pick-up address straight away.
                  </p>
                </div>
                <div>
                  <h2 className={css.sectionTitle}>Key Benefits:</h2>
                  <div className={css.glanceSection}>
                    <div className={css.glanceRow}>
                      <IconSuccess fillColor={'var(--marketplaceColor)'} />
                      <span>
                        <b>Immediate confirmation</b> after you place your request
                      </span>
                    </div>
                    <div className={css.glanceRow}>
                      <IconSuccess fillColor={'var(--marketplaceColor)'} />
                      <span>
                        <b>Pick-up details sent instantly</b> — no need to wait
                      </span>
                    </div>
                    <div className={css.glanceRow}>
                      <IconSuccess fillColor={'var(--marketplaceColor)'} />
                      <span>
                        <b>Perfect for last-minute hires</b> or urgent plans
                      </span>
                    </div>
                    <div className={css.glanceRow}>
                      <IconSuccess fillColor={'var(--marketplaceColor)'} />
                      <span>
                        <b>Backed by our secure</b> booking system
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className={css.section}>
              <div className={css.sectionContent}>
                <h1 className={css.sectionTitle}>Important Note</h1>
                <div className={css.importantNote}>
                  <p>
                    Not all trailers are Instant Book enabled. Look for the ⚡️ Instant Book tag
                    when browsing listings.
                  </p>
                </div>
              </div>
            </li>

            <li className={css.section}>
              <div className={css.sectionContent}>
                <h1 className={css.sectionTitle}>FAQs</h1>
                <div className={css.faqSection}>
                  <FAQ category={'instant-book'} />
                </div>
              </div>
            </li>
          </ul>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default InstantBookingPage;
